import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AIReceptionistLanding from "./components/AIReceptionistLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AIReceptionistLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;